import {
  CampaignField,
  CampaignSingleSelectInputField,
} from '../model/campaign-field';
import { isInputField, isSelectInputField } from './form-field.guard';

/**
 * Type guard for checking campaign select fields
 *
 * @param field Field to check
 *
 * @returns
 * `true`, if `field` is a campaign select field
 */
export function isCampaignSelectField(
  field: CampaignField | undefined,
): field is CampaignSingleSelectInputField {
  return (
    !!field &&
    isInputField(field?.widgetType) &&
    isSelectInputField(field.widgetOptions)
  );
}
